export const getSubscriptionTypeTagColours = (subscriptionType: string) => {
  const colours = [
    {
      backgroundColor: '#4376B4',
      color: '#FFF'
    },
    {
      backgroundColor: '#23BD6A',
      color: '#FFF'
    }
  ];

  if (subscriptionType.toLowerCase() === 'subscription') return colours[0];

  return colours[1];
};
